'use client'
import React, { useState } from 'react'
import HeroSection from '@/components/industry-co-led/HeroSection';
import AboutProgram from '@/components/industry-co-led/AboutProgram';
import OurOffering from "@/components/industry-co-led/OurOffering"
import { masterAdvCareParam } from '@/data/industry-co-led/redversity/masterAdvCareParam';
import { courseDetails } from '@/data/industry-co-led/redversity/courseDetails';
import WhySection from '@/components/industry-co-led/WhySection';
import MSUAdvantages from '@/components/industry-co-led/MSUAdvantages';
import CTASection from '@/components/industry-co-led/ui/CTASection';
import Eligibility from '@/components/industry-co-led/Eligibility';
import CurriculumStructure from "@/components/industry-co-led/CurriculumStructure";
import StudentStoriesSection from "@/components/industry-co-led/medhavianSpeak";
import FAQSection from "@/components/industry-co-led/FAQSection";
import InfrastructureSection from "@/components/industry-co-led/InfrastructureSection";
import AdditionalSkills from "@/components/industry-co-led/addintionSkill"
import OnTheJobTraining from '@/components/industry-co-led/OnTheJobTraining';
import UserFormModal from '@/components/industry-co-led/UserFormModal';
import { useFormModal } from "@/context/FormContext";
import VideoModal from '@/components/videoModel';
import CareerProspects from '@/components/industry-co-led/CareerProspects';
import EligibilitySection from '@/components/industry-co-led/EligibilitySection';
import CourseStickyBar from '@/components/industry-co-led/CourseSticky';
const MasterAdvCareParam = () => {
    const {
        isOpen,
        shouldDownload,
        closeForm,
        handleSuccess,
        openDownloadForm,
        openApplyForm,
        modal,
        closeVideo,
    } = useFormModal();

    const brochureUrl =
        "https://cdn.msu.edu.in/pdf/MSU_Fee_Structure_2026_27.pdf";

    const brochureName =
        "Master.pdf";

    return (
        <>
            <section className="w-full ">
                <HeroSection data={masterAdvCareParam}
                    onDownload={() =>
                        openDownloadForm(
                            brochureUrl,
                            brochureName
                        )
                    }
                    onApply={() =>
                        openApplyForm()
                    }
                />
                <AboutProgram data={masterAdvCareParam} />
                <OurOffering data={masterAdvCareParam} />
                <WhySection data={masterAdvCareParam} />
                <MSUAdvantages data={masterAdvCareParam} />
                <CTASection data={masterAdvCareParam}
                    onApplyNow={openApplyForm}
                />
                <OnTheJobTraining
                    data={masterAdvCareParam.onJobtrainningData}
                />
                <AdditionalSkills courseSections={masterAdvCareParam.addtionSkill.courseSections}
                    onApplyNow={openApplyForm}
                />
                <InfrastructureSection data={masterAdvCareParam.DoExperienceLearndata} />
                <StudentStoriesSection studentStoriesData={masterAdvCareParam.studentStoriesData} />
                <EligibilitySection data={masterAdvCareParam} onApplyNow={openApplyForm} />

                <CareerProspects data={masterAdvCareParam.careerProspects} />

                <CurriculumStructure curriculumData={masterAdvCareParam.curriculumStructure} />
                <FAQSection course={masterAdvCareParam.faq} />
            </section>

            <UserFormModal
                isOpen={isOpen}
                onClose={closeForm}
                onSuccess={handleSuccess}
                shouldDownload={shouldDownload}
                courseDetails={courseDetails.redversity.PG}
                specialization={"Advanced Care Paramedic"}
                course={"M. Sc. (2 Years)"}
                schoolName={"Health Science & Technology"}
                stream={""}
            />

            <VideoModal
                open={modal.open}
                url={modal.url}
                onClose={closeVideo}
            />
            <CourseStickyBar coursePrice={masterAdvCareParam.coursePrice} onApply={() => openApplyForm()} />

        </>
    )
}

export default MasterAdvCareParam